import { alarmCRUD, type AlarmCrudType } from './alarm-crud'
import { applicationCrud, type ApplicationCrudType } from './application-crud'
import { blobCRUD, type BlobCrudType } from './blob-crud'
import { facilityCRUD, type FacilityCrudType } from './facility-crud'
import { earthquakeCRUD, type EarthquakeCrudType } from './earthquake-crud'
import { photovoltaicCRUD, type PhotovoltaicCrudType } from './photovoltaic-crud'
import { plcCRUD, type PLCCrudType } from './plc-crud'
import { roleCRUD, type RoleCrudType } from './role-crud'
import { userCRUD, type UserCrudType } from './user-crud'
import { bmsCRUD, type BMSCrudType } from './bms-crud'
type FetchOptionsType = { cache?: RequestCache; timeout?: number }

type ApiType = () => {
    application: ApplicationCrudType
    blob: BlobCrudType
    facility: FacilityCrudType
    earthquake: EarthquakeCrudType
    user: UserCrudType
    role: RoleCrudType
    plc: PLCCrudType
    alarm: AlarmCrudType
    photovoltaic: PhotovoltaicCrudType
    bms: BMSCrudType
}

const api: ApiType = () => ({
    application: () => applicationCrud(),
    blob: () => blobCRUD(),
    facility: () => facilityCRUD(),
    earthquake: () => earthquakeCRUD(),
    plc: () => plcCRUD(),
    user: () => userCRUD(),
    role: () => roleCRUD(),
    alarm: () => alarmCRUD(),
    photovoltaic: () => photovoltaicCRUD(),
    bms: () => bmsCRUD(),
})

export { api, type ApiType, type FetchOptionsType }
